// Components
const MatingDamSireDetails = () =>
    import(
        /*webpackChunkName: "mating-dam-sire-details-container" */ "@/app/views/main-view/breeding-management/puppy-management/containers/litter-list-container/components/mating-dam-sire-details-container/mating-dam-sire-details-container.vue"
    );

const ModalViewDocument = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-view-document" */ "@/app/views/main-view/general-info/modals/modal-view-document/modal-view-document.vue");

// Services
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";

// Constants
import { SUCCESS_MSG, STATUS_CODES } from "@/app/constants/status-constants";
import { BREEDER_ROUTES } from "@/app/constants/breeder-routes-constants";

const PUPPIES_LIMIT = 15;

export default {
    name: "WaitlistTableContainer",
    components: { MatingDamSireDetails, ModalViewDocument },
    directive: {},
    filters: {},
    mixins: [toastMessageMixins, tableMixins],
    props: {},
    data() {
        return {
            isAPILoading: false,
            isTableAPILoading: false,

            matingDetails: null,
            matingName: "",
            damDetails: null,
            sireDetails: null,

            // table
            theads: [
                { name: null, searchLabel: null, sortLabel: null, isDesc: false, style: "width: 100px" },
                {
                    name: "Client",
                    hasSearch: true,
                    searchLabel: "f_client",
                    sortLabel: "client",
                    isDesc: false,
                    style: "min-width: 180px;",
                },
                {
                    name: "Phone No.",
                    searchLabel: "f_phoneNumber",
                    sortLabel: "phoneNumber",
                    hasSearch: true,
                    isDesc: false,
                    style: "min-width: 180px;",
                },
                {
                    name: "Email Address",
                    hasSearch: true,
                    searchLabel: "f_emailAddress",
                    sortLabel: "emailAddress",
                    isDesc: false,
                    style: "min-width: 210px;",
                },
                {
                    name: "Puppy",
                    hasSearch: true,
                    searchLabel: "f_puppyName",
                    sortLabel: "puppyName",
                    isDesc: false,
                    style: "min-width: 150px;",
                },
                {
                    name: "Price",
                    hasSearch: true,
                    searchLabel: "f_price",
                    sortLabel: "price",
                    isDesc: false,
                    style: "min-width: 140px;",
                },
                {
                    name: "Deposit",
                    hasSearch: true,
                    searchLabel: "f_deposit",
                    sortLabel: "deposit",
                    isDesc: false,
                    style: "min-width: 160px;",
                },
                {
                    name: "Balance",
                    hasSearch: true,
                    searchLabel: "f_balance",
                    sortLabel: "balance",
                    isDesc: false,
                    style: "min-width: 160px;",
                },
                {
                    name: "Contract",
                    hasSearch: true,
                    searchLabel: "f_contractName",
                    sortLabel: "contractName",
                    isDesc: false,
                    style: "min-width: 180px;",
                },
            ],

            desc: true,
        };
    },
    computed: {},
    watch: {},
    async created() {
        if (this.$route.query) {
            this.matingId = this.$route.query.matingId;
            await this.getDamAndSireMatingDetails(this.$route.query.matingId);
            this.getTableContent();
        }
    },
    methods: {
        getTableContent(page = this.page, limit = PUPPIES_LIMIT, sortBy = this.sortBy, desc = this.desc, fromFilter = false) {
            page = fromFilter ? 1 : this.page;
            this.getWaitList({ page, limit, sortBy, desc });
        },
        async getWaitList(queryParams) {
            this.isTableAPILoading = true;

            if (this.columnsFilter) {
                if (this.columnsFilter.f_client) {
                    queryParams["f_client"] = this.columnsFilter.f_client;
                }
                if (this.columnsFilter.f_phoneNumber) {
                    queryParams["f_phoneNumber"] = this.columnsFilter.f_phoneNumber;
                }
                if (this.columnsFilter.f_emailAddress) {
                    queryParams["f_emailAddress"] = this.columnsFilter.f_emailAddress;
                }
                if (this.columnsFilter.f_puppyName) {
                    queryParams["f_puppyName"] = this.columnsFilter.f_puppyName;
                }
                if (this.columnsFilter.f_price) {
                    queryParams["f_price"] = this.columnsFilter.f_price;
                }
                if (this.columnsFilter.f_deposit) {
                    queryParams["f_deposit"] = this.columnsFilter.f_deposit;
                }
                if (this.columnsFilter.f_balance) {
                    queryParams["f_balance"] = this.columnsFilter.f_balance;
                }
                if (this.columnsFilter.f_contractName) {
                    queryParams["f_contractName"] = this.columnsFilter.f_contractName;
                }
            }

            try {
                const response = await breedingManagementService.getWaitlist(this.matingId, queryParams);
                if (response.status === STATUS_CODES.SUCCESS) {
                    this.tableContent = {
                        tableData: response.data.data,
                        paginationData: response.data.pagination,
                    };
                } else {
                    this.showGenericErrorToast();
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isTableAPILoading = false;
            }
        },
        async getDamAndSireMatingDetails(matingId) {
            if (!matingId) {
                return;
            }

            try {
                this.isAPILoading = true;
                const matingDetailsResponse = await breedingManagementService.getDamAndSireMatingDetails("mating", matingId);

                if (matingDetailsResponse.status === STATUS_CODES.SUCCESS) {
                    const { data: matingDetails } = matingDetailsResponse;

                    this.damDetails = matingDetails.damDetails;
                    this.sireDetails = matingDetails.sireDetails;
                    this.matingName = matingDetails.alias;
                    this.matingDetails = matingDetails;
                    if (matingDetails.damDetails && matingDetails.damDetails.whelpingDates && matingDetails.damDetails.whelpingDates.length > 0) {
                        const lastRecord = matingDetails.damDetails.whelpingDates[matingDetails.damDetails.whelpingDates.length - 1];
                        if (lastRecord.typeOfBirth && lastRecord.matingId === matingDetails.id) {
                            this.typeOfBirth = lastRecord.typeOfBirth;
                        }
                    }
                } else {
                    const { ERROR_GET_MATING_DETAILS } = this.toastMessages.mating();
                    this.showAPIErrorToast(ERROR_GET_MATING_DETAILS, matingDetailsResponse);
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAPILoading = false;
            }
        },
        redirectToAllocatePuppy() {
            this.$router.push(`${BREEDER_ROUTES.ALLOCATE_PUPPY}?matingId=${this.matingId}`);
        },
        async previewDocument(data) {
            const { fileURL, fileType, fileName } = data;

            const imageTypes = ["image/png", "image/jpeg", "image/jpg", "png", "jpg", "jpeg"];

            if (imageTypes.includes(fileType) || fileType === "pdf" || fileType === "application/pdf") {
                // format document to match the keys received by modalViewDocument component
                const formattedDocument = {
                    documentUrl: fileURL,
                    type: fileType,
                    name: fileName,
                };

                this.$refs.modalViewDocument.show(formattedDocument, imageTypes);
            } else {
                window.open(fileURL, "_blank"); // doc/docx will be downloaded automatically
            }
        },
        editWaitlistItem(allocatedPuppy){
            if(!allocatedPuppy && !allocatedPuppy.id){
                return;
            }

            this.$router.push(`${BREEDER_ROUTES.EDIT_ALLOCATED_PUPPY}?allocatedPuppyId=${allocatedPuppy.id}&matingId=${this.matingId}`);
        },
        deleteWaitlistItem(allocatedPuppy){
            if(!allocatedPuppy && !allocatedPuppy.id){
                return;
            }

            this.$swal({
                imageHeight: "30px",
                // imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
                // imageAlt: "Sad Dog",
                title: `Delete Allocated Puppy`,
                text: "Are you sure you want to delete the allocated puppy?",
                confirmButtonText: "Confirm",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                showCloseButton: true, 
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                        breedingManagementService.deleteAllocatedPuppyById(allocatedPuppy.id).then((res) => {
                        if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                            this.getTableContent();
                            const { SUCCESS_DELETE_WAITLIST } = this.toastMessages.waitlist();
                            this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_DELETE_WAITLIST);
                        } else {
                            const { ERROR_DELETE_WAITLIST } = this.toastMessages.waitlist();
                            this.showAPIErrorToast(ERROR_DELETE_WAITLIST, res);
                        }
                    });
                }
            });
        },
        redirectToPuppyList(){
            this.$router.push(`${BREEDER_ROUTES.LITTER_LIST}?id=${this.matingId}`);
        },
    },
    // third party libraries
};
